// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tl-0";